export const SET_DEMO_PROJECT  = 'SET_DEMO_PROJECT';
export const CHANGE_DEMO_STYLE  = 'CHANGE_DEMO_STYLE';